<template>
    <div class="completeMain">
        <div>
            <span>论文写作已完成！</span>
        </div>
    </div>
</template>
<script>
export default {
    name: "complete",
    data() {
        return {

        }
    }
}
</script>
<style  lang="less" scoped>
.completeMain{
    padding-top: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    font-size: 26px;
}
</style>


// WEBPACK FOOTER //
// src/pages/transactionPaper/writeGroup/complete.vue